'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultCategories = exports.defaultCategories = { // eslint-disable-line
  people: {
    title: 'People',
    emoji: 'smile'
  },
  nature: {
    title: 'Nature',
    emoji: 'hamster'
  },
  food: {
    title: 'Food & Drink',
    emoji: 'pizza'
  },
  activity: {
    title: 'Activity',
    emoji: 'soccer'
  },
  travel: {
    title: 'Travel & Places',
    emoji: 'earth_americas'
  },
  objects: {
    title: 'Objects',
    emoji: 'bulb'
  },
  symbols: {
    title: 'Symbols',
    emoji: 'clock9'
  },
  flags: {
    title: 'Flags',
    emoji: 'flag_gb'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/emojione-picker/lib/constants.js
// module id = 1080
// module chunks = 2